import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const STYLES = {
  resolved: {
    bg: '#d4edda',
    fg: '#155724',
    label: '✓ Resolved',
    desc: 'Fix flow finished cleanly — either the backend heartbeat confirmed the fault was cleared, the driver explicitly reported no issue (COMPLETION_FEEDBACK hadIssue=false), or the flow had no verification step and WORKFLOW_COMPLETED is its natural terminal.',
  },
  escalated: {
    bg: '#fff3cd',
    fg: '#856404',
    label: '↻ Escalated',
    desc: 'Ops follow-up needed. Either the backend re-check still saw the fault (HEARTBEAT_RESULT issue_detected), the driver reported the fix did not work (COMPLETION_FEEDBACK hadIssue=true), or the driver pushed past a heartbeat check that never returned a result.',
  },
  unverified: {
    bg: '#cfe2ff',
    fg: '#084298',
    label: '⚠ Unverified',
    desc: 'Driver finished the fix but the verification step could not reach a conclusion — re-query timed out (connection_error_final), the driver skipped the connectivity-error screen (connection_skipped), or the heartbeat returned an unrecognized outcome.',
  },
  skipped: {
    bg: '#e2e3e5',
    fg: '#383d41',
    label: '⊘ Skipped',
    desc: 'Driver skipped the entire fix workflow before working through this fix.',
  },
  abandoned: {
    bg: '#f8d7da',
    fg: '#721c24',
    label: '∅ Abandoned',
    desc: 'Driver started the flow but never reached a terminal event — no completion feedback, no heartbeat result, no workflow completion.',
  },
};

const OutcomePill = ({ outcome }) => {
  const style = STYLES[outcome] || {
    bg: '#eee',
    fg: '#333',
    label: outcome,
    desc: '',
  };
  const pill = (
    <span
      style={{
        backgroundColor: style.bg,
        color: style.fg,
        padding: '2px 8px',
        borderRadius: '12px',
        fontSize: '0.85em',
        fontWeight: 600,
        whiteSpace: 'nowrap',
        display: 'inline-block',
        cursor: style.desc ? 'help' : 'default',
      }}
    >
      {style.label}
    </span>
  );
  if (!style.desc) return pill;
  return (
    <OverlayTrigger
      placement="top"
      overlay={
        <Tooltip id={`outcome-tooltip-${outcome}`}>
          <div style={{ textAlign: 'left', maxWidth: '280px' }}>
            {style.desc}
          </div>
        </Tooltip>
      }
    >
      {pill}
    </OverlayTrigger>
  );
};

export default OutcomePill;
